import { ICampgroundLocation } from '@/services/types/search/campgrounds/id';
import { getStateName, provinceByCountry, TCountry } from '@/utility/location';

export const getFormattedCampgroundLocation = (location?: ICampgroundLocation) => {
  if (!location) return {};
  const { state, street, city, country, zip } = location;
  const formattedCountry = (country?.toUpperCase() as TCountry) || 'US';

  const stateName = getStateName(state, formattedCountry) ?? state;
  const countryName = provinceByCountry[formattedCountry].name;

  const campgroundAddress = [street, city, `${stateName} ${zip}`, countryName].join(', ');
  return { stateName, countryName, campgroundAddress };
};
